import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  if (user && user !== false) {
    const to = loc.state?.from?.pathname || "/admin";
    return <Navigate to={to} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const r = await login(email.trim().toLowerCase(), password);
    setLoading(false);
    if (!r.ok) setErr(r.error);
  };

  return (
    <div className="min-h-screen paper-bg flex items-center justify-center px-6 py-20" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center">
          <div className="inline-flex items-center justify-center h-12 w-12 border border-[#8b2e3e] text-[#8b2e3e] mx-auto">
            <Lock size={18} />
          </div>
          <p className="eyebrow mt-6">Author Portal</p>
          <h1 className="font-serif text-4xl text-[#1c1a1a] mt-2 tracking-tight">Welcome back</h1>
          <p className="mt-3 text-[#4a4646]">Sign in to view messages and subscribers.</p>
        </div>

        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="mt-10 bg-white border border-[#e5dcd0] p-8 space-y-6"
        >
          <div>
            <label className="eyebrow !text-[#4a4646] block mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              data-testid="admin-login-email"
              className="w-full border-b border-[#e5dcd0] bg-transparent px-1 py-3 text-lg font-serif text-[#1c1a1a] focus:outline-none focus:border-[#8b2e3e] transition-colors"
            />
          </div>
          <div>
            <label className="eyebrow !text-[#4a4646] block mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              data-testid="admin-login-password"
              className="w-full border-b border-[#e5dcd0] bg-transparent px-1 py-3 text-lg font-serif text-[#1c1a1a] focus:outline-none focus:border-[#8b2e3e] transition-colors"
            />
          </div>

          {err && (
            <p data-testid="admin-login-error" className="text-sm text-[#8b2e3e] bg-[#f4d8d8]/40 border border-[#e5c9c5] px-3 py-2">
              {err}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="btn-rose w-full inline-flex items-center justify-center gap-2 bg-[#8b2e3e] hover:bg-[#6d2230] text-white px-7 py-4 text-sm tracking-[0.15em] uppercase transition-colors disabled:opacity-60"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : null}
            Sign in
          </button>
        </form>

        <p className="text-center mt-8 text-xs text-[#4a4646]">
          Protected area · <a href="/" className="link-underline">← Back to site</a>
        </p>
      </div>
    </div>
  );
}
